<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col md="6" xl="4" v-for="(item, index) in items" :key="index">
        <v-card
          elevation="4"
          :to="item.to"
          class="mx-auto"
          outlined
          :disabled="item.disabled"
        >
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title
                :class="
                  $vuetify.breakpoint.smAndDown ? 'title mb-1' : 'headline mb-1'
                "
              >
                {{ item.name }}
              </v-list-item-title>
              <v-list-item-subtitle v-if="item.groupName">
                <v-chip label color="primary">
                  {{ item.groupName }}
                </v-chip></v-list-item-subtitle
              >
            </v-list-item-content>

            <v-list-item-avatar tile size="80" color="transparent">
              <v-icon
                x-large
                :color="$vuetify.theme.isDark ? 'gray' : 'primary'"
                >{{ item.icon }}</v-icon
              >
            </v-list-item-avatar>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          groupName: this.$t("navigationBar.module"),
          name: this.$t("navigationBar.titles.assets"),
          icon: "mdi-cogs",
          to: "/assets",
          disabled: false
        },
        {
          groupName: this.$t("navigationBar.module"),
          name: this.$t("navigationBar.titles.worksModule"),
          icon: "mdi-account-hard-hat",
          to: "/works",
          disabled: !this.$store.getters["auth/equipmentWrite"]
        },
        {
          groupName: this.$t("navigationBar.module"),
          name: this.$t("navigationBar.titles.stocks"),
          icon: "mdi-clipboard-list",
          to: "/stocks",
          disabled: !this.$store.getters["auth/equipmentWrite"]
        },
        {
          groupName: this.$t("navigationBar.module"),
          name: this.$t("navigationBar.titles.calendar"),
          icon: "mdi-calendar",
          to: "/calendar",
          disabled: false
        },
        {
          groupName: null,
          name: this.$t("navigationBar.titles.support"),
          icon: "mdi-alert-circle-outline",
          to: "/tickets",
          disabled: false
        },
        {
          groupName: null,
          name: this.$t("navigationBar.titles.userProfile"),
          icon: "mdi-account-cog",
          to: "/user-profile",
          disabled: false
        }
      ]
    };
  }
};
</script>

<style></style>
